import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
    providedIn: 'root',
})
export class VillageStaffService {
    constructor(private httpClient: HttpClient) { }
    getParkingReason(): Observable<any> {
        return this.httpClient.get('api/reason/get').pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    getVillageStaffWavier(data): Observable<any> {
        return this.httpClient.post('api/villagestaff/wavier', { data }).pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    getEnforcemetHistory(data): Observable<any> {
        return this.httpClient.post('api/villagestaff/enforcement', { data }).pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    createParkingPermit(data): Observable<any> {
        // data.streetId = '98733782'
        // data.reasonId = '53hgy34811u342u43125'
        return this.httpClient.post('api/villagestaff/createpermit', { data }).pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    getPartkingPermits(data): Observable<any> {
        return this.httpClient.post('api/villagestaff/getPermits', { data }).pipe(
            map((body: any) => {
                if (body.status === 200) {
                    throw new Error(body.response.message);
                } else {
                    return body;
                }
            })
        )
    }

    updateWaiverCount(data){
        return this.httpClient.post('api/villagestaff/updateWaiverCount', { data }).pipe(
            map((body: any) => {
                if (body == 500) {
                    throw new Error('error');
                } else {
                    return body;
                }
            })
        )
    }
}